/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
// react component used to create charts
import ChartistGraph from "react-chartist";
// react components used to create a SVG / Vector map
import { VectorMap } from "react-jvectormap";

import Card from "components/Card/Card.jsx";
import StatsCard from "components/Card/StatsCard.jsx";
import Tasks from "components/Tasks/Tasks.jsx";
import { searchOrders } from "../Listfunction";

import {
  dataPie,
  dataSales,
  optionsSales,
  responsiveSales,
  dataBar,
  optionsBar,
  responsiveBar,
  table_data,
} from "variables/Variables.jsx";

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920,
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalSalesToday: 0,
      totalSalesYesterday: 0,
    };
  }

  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows
        .push
        // <tr key={i}>
        //   <td>
        //     <div className="flag">
        //       <img src={table_data[i].flag} alt="us_flag" />
        //     </div>
        //   </td>
        //   <td>{table_data[i].country}</td>
        //   <td className="text-right">{table_data[i].count}</td>
        //   <td className="text-right">{table_data[i].percentage}</td>
        // </tr>
        ();
    }
    return tableRows;
  }

  componentDidMount() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + "-" + mm + "-" + dd;

    var yesterday = new Date(Date.now() - 864e5);
    var dd = String(yesterday.getDate()).padStart(2, "0");
    var mm = String(yesterday.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = yesterday.getFullYear();
    yesterday = yyyy + "-" + mm + "-" + dd;

    this.getDashboardData(today, "today");
    this.getDashboardData(yesterday, "yesterday");
  }

  getDashboardData = (date, orderDate) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    searchOrders("", "", "", "", date, "", "", obj)
      .then((response) => {
        if (orderDate == "today") {
          this.setState({
            totalSalesToday: response.data.total,
          });
        } else {
          this.setState({
            totalSalesYesterday: response.data.total,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-server text-warning" />}
                statsText="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total Orders today"
                statsValue={this.state.totalSalesToday}
                statsIcon={<i className="fa fa-refresh" />}
                statsIconText="Updated now"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-wallet text-success" />}
                statsText="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Yesterday's Total Orders"
                statsValue={this.state.totalSalesYesterday}
                statsIcon={<i className="fa fa-calendar-o" />}
                statsIconText="Last day"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-graph1 text-danger" />}
                statsText="Last Week Orders"
                statsValue="23"
                statsIcon={<i className="fa fa-clock-o" />}
                statsIconText="In the last hour"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="fa fa-twitter text-info" />}
                statsText="Last Month's Orders"
                statsValue="+45"
                statsIcon={<i className="fa fa-refresh" />}
                statsIconText="Updated now"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Total Orders & Sales Today"
                // category="All products that were shipped"
                content={
                  <Row>
                    <Col md={5}>
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            {/* <React.Fragment> */}
                            <tr>
                              <td
                                className="text-left"
                                style={{ fontWeight: "bold" }}
                              >
                                Source
                              </td>
                              <td
                                className="text-left"
                                style={{ fontWeight: "bold" }}
                              >
                                Orders
                              </td>
                              <td
                                className="text-left"
                                style={{ fontWeight: "bold" }}
                              >
                                Revenue
                              </td>
                            </tr>
                            <tr>
                              <td className="text-left">Flash</td>
                              <td className="text-left">10</td>
                              <td className="text-left">20000</td>
                            </tr>
                            <tr>
                              <td className="text-left">Opharma</td>
                              <td className="text-left">10</td>
                              <td className="text-left">40000</td>
                            </tr>
                            <tr>
                              <td className="text-left">MyPharma</td>
                              <td className="text-left">10</td>
                              <td className="text-left">20000</td>
                            </tr>
                            <tr>
                              <td className="text-left">&nbsp;&nbsp;</td>
                              <td className="text-left">30</td>
                              <td className="text-left">80000</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col md={6} mdOffset={1}>
                      <VectorMap
                        map={"world_mill"}
                        backgroundColor="transparent"
                        zoomOnScroll={false}
                        containerStyle={{
                          width: "100%",
                          height: "280px",
                        }}
                        containerClassName="map"
                        regionStyle={{
                          initial: {
                            fill: "#e4e4e4",
                            "fill-opacity": 0.9,
                            stroke: "none",
                            "stroke-width": 0,
                            "stroke-opacity": 0,
                          },
                        }}
                        series={{
                          regions: [
                            {
                              values: mapData,
                              scale: ["#AAAAAA", "#444444"],
                              normalizeFunction: "polynomial",
                            },
                          ],
                        }}
                      />
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={8}></Col>
          </Row>
          <Row>
            <Col md={6}>
              <Card
                title="2014 Sales"
                category="All products including Taxes"
                content={
                  <ChartistGraph
                    data={dataBar}
                    type="Bar"
                    options={optionsBar}
                    responsiveOptions={responsiveBar}
                  />
                }
                legend={
                  <div>
                    <i className="fa fa-circle text-info" /> Tesla Model S
                    <i className="fa fa-circle text-danger" /> BMW 5 Series
                  </div>
                }
                stats={
                  <div>
                    <i className="fa fa-check" /> Data information certified
                  </div>
                }
              />
            </Col>
            <Col md={6}>
              <Card
                title="Tasks"
                category="Backend development"
                content={
                  <table className="table">
                    <Tasks />
                  </table>
                }
                stats={
                  <div>
                    <i className="fa fa-history" /> Updated 3 minutes ago
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Dashboard;
